import { Chart } from 'highcharts';
import { InjectionKey } from 'vue';

export type HighchartsInstance = {
  chart: InstanceType<typeof Chart>;
};

// Injection-Function to reload trends from somewhere down the tree
type ReloadTrendsFunction = () => void;
export const reloadTrendsKey: InjectionKey<ReloadTrendsFunction> = Symbol();
